import React from 'react';
import { Empty } from 'antd';
import {
  EmptyRow,
  TableRow,
  TableCell,
  TableBody,
} from '../../../../../../components/customTableComponents';
import CallListRow from '../CallListRow/CallListRow';

const NoData = () => {
  return (
    <>
      <EmptyRow />
      <TableRow>
        <TableCell colSpan={9} transparent>
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </TableCell>
      </TableRow>
    </>
  );
};

const CallListBody = ({ calls }) => {
  return (
    <TableBody>
      {calls?.length > 0 ? (
        calls.map((call) => <CallListRow key={call.uniqueId} call={call} />)
      ) : (
        <NoData />
      )}
    </TableBody>
  );
};

export default CallListBody;
